import React, { useEffect, useRef, useState } from "react";
import play from "../../Assets/img/play-button (2) 4.svg";
import { BASE_URL, FILE_URL, testimonialApi } from "../../API/Api";
import { Link } from "react-router-dom";

const Testimonials = () => {
  const videoRefs = useRef([]);
  const [videos, setVideos] = useState([]);
  const [playingIndex, setPlayingIndex] = useState(null); // track which video is playing

  // Fetch latest 2 testimonial videos
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await testimonialApi.getTestimonials();
        const latest = res.slice(-2).reverse(); // latest 2
        const mappedVideos = latest.map((vid) => ({
          videoUrl: vid.video ? `${FILE_URL}${vid.video}` : "",
          posterUrl: vid.img ? `${FILE_URL}${vid.img}` : "",
          name: vid.name,
          postOfPerson: vid.postOfPerson,
        }));
        setVideos(mappedVideos);
      } catch (err) {
        console.error("❌ Error fetching testimonials:", err);
      }
    };
    fetchVideos();
  }, []);

  const handlePlay = (index) => {
    const video = videoRefs.current[index];
    if (!video) return;

    if (video.paused) {
      // Pause other videos
      videoRefs.current.forEach((v, i) => {
        if (i !== index && v && !v.paused) v.pause();
      });
      video.play();
      setPlayingIndex(index); // show overlay only for paused videos
    } else {
      video.pause();
      setPlayingIndex(null);
    }
  };

  // Optional: hide overlay when video ends
  const handleEnded = () => {
    setPlayingIndex(null);
  };

  return (
    <>
      {/* Inquiry Section */}
      <section className="contact-box-inquiry mb-0">
        <div className="inquiry-box">
          <h2>Have more questions? Let’s connect!</h2>
          <p>
            Book a free consultation with our expert to get all your questions
            answered. <br />
            We’re here to help you choose the right plan.
          </p>
          <div className="text-center d-flex justify-content-center">
            <Link to="/contact-us" style={{ textDecoration: "none" }}>
              <button type="button" className="btn-purple">
                Schedule a Meeting
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="vidio-box">
        <h2>Our Valued Clients</h2>
        <div className="container">
          <div className="row justify-content-center g-4">
            {videos.map((vid, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-5 col-lg-4">
                {vid.videoUrl ? (
                  <div
                    className="card-video position-relative"
                    onClick={() => handlePlay(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      src={vid.videoUrl}
                      className="testimonial-video"
                      preload="metadata"
                      poster={vid.posterUrl}
                      onEnded={handleEnded}
                    />
                    {playingIndex !== index && (
                      <span className="play-button position-absolute top-50 start-50 translate-middle">
                        <img
                          src={play}
                          style={{ height: "34px", width: "34px" }}
                          alt="Play"
                        />
                      </span>
                    )}
                  </div>
                ) : (
                  <p>No video available</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
